<template lang="pug">
  #signInIndex
    .searchArea.mt-3.mx-3
      b-form-input.inputStyle(
        id="mobile",
        type="text",
        required,
        trim,
        v-model="mobile",
        placeholder="請輸入顧客姓名",
      )

      .row.no-gutters.mt-3
        .col-1
        .col-4
          b-button.btn-sm(
            variant="primary",
            block,
            @click="resetDetail()"
          ) 清除
        .col-2
        .col-4
          b-button.btn-sm(
            variant="primary",
            block,
            @click="getShopDetail()"
          ) 確認
    .container-width.mt-3(style='border: 1px solid' v-if='detail && detail.length !== 0')
      .infoArea.d-flex.no-gutters(style='border-bottom: 1px solid #E0E0E0')
        .d-flex.col-3.align-items-center.justify-content-center(style='background-color: #000; color: #FFF')
          p.py-1.px-3.mb-0 {{ detail.content.vtype.substr(0, 2) }}
        .d-flex.col-3.my-2.align-items-center.justify-content-center(style='border-right: 1px solid')
          p.ml-2.mb-0.pr-2 {{ detail.content.name }}
        .d-flex.col-6.my-1.align-items-center.justify-content-center
          p.py-1.ml-2.mb-0 續卡差額 : {{ detail.content.requiredAmount > 0 ? 0 : detail.content.requiredAmount * -1 }}
      .tagArea(style='border-bottom: 1px solid #E0E0E0' v-if='memberBackendTag.length > 0')
        .mx-3.my-1
          .d-flex(style='flex-wrap: wrap;')
            .tag.m-2(v-for="(tag, index) in memberBackendTag")
              .py-2.px-3(style='border: 1px solid #000; border-radius: 40px;') {{ tag.name }}
      .shoppingSheetArea.mt-3.mx-4.pt-2
        p 消費紀錄 : (顯示近1年的消費紀錄)
        .detailArea.position-relative.mb-3(v-for="(detail, index) in detail.content.shoppingDetail")
          div.position-relative
            p.mb-1
              small {{ detail.txDate }}  {{ detail.shopName }}
            p.mb-1
              small 訂單 : {{ detail.memoNo }}
            p.mb-1
              small 共 : {{ detail.orderAmount }}
            i.fas.fa-chevron-right.position-absolute(style='right: 0; top: 50%' v-if="!detail.show" @click='showDetail(index, true)')
            i.fas.fa-chevron-right.position-absolute(style='right: 0; top: 50%; transform: rotate(90deg)' v-else @click='showDetail(index, false)')
          div(style="background-color: #F0F0F0" v-show="detail.show")
            .py-3
              .productDetailArea.mx-3.py-1(v-for='(productDetail, index) in detail.detail')
                p.mb-1
                  .col-12
                    small {{ productDetail.description }}
                .d-flex
                  .col-6.mb-1
                    small 數量 : {{ productDetail.actualSalesQty }}
                  .col-6.mb-1
                    small 金額 : {{ productDetail.amount }}

    .text-center.mt-4(v-else-if="detail && detail.length === 0")
      span 查無資料

</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'cardIndex',
  components: {
  },
  data() {
    return {
      detail: null,
      mobile: null,
    };
  },
  mounted() {
    const vm = this;
    // 檢查綁定狀態
    vm.$store.commit('toggleLoading', true);

    vm.$store.dispatch('sm_profile/getProfileHandler')
      .then((res) => {
        vm.$store.commit('toggleLoading', false);
      });
  },
  methods: {
    showDetail(index, status) {
      const vm = this;
      vm.$set(vm.detail.content.shoppingDetail[index], 'show', status);
    },
    getShopDetail() {
      const vm = this;
      vm.detail = null;
      vm.$swal.fire({
        title: '取得顧客資料中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          vm.$swal.showLoading();
        }
      });

      vm.$store.dispatch('sm_member_search/getShopDetailHandler', vm.mobile).then(() => {
        vm.detail = _.cloneDeep(vm.shopDetail);
        vm.$swal.close();
      });
      vm.$store.dispatch('sm_member_search/getBackendTagByMobileHandler', vm.mobile).then(() => {
      });
    },
    resetDetail() {
      const vm = this;
      vm.detail = null;
    }
  },
  computed: {
    ...mapState({
      shopDetail: (state) => state.sm_member_search.shopDetail,
      memberBackendTag: (state) => state.sm_member_search.memberBackendTag
    })
  }
};
</script>

<style scoped>
  .detailArea:not(:last-child) {
    border-bottom: 1px solid #000;
  }
  .productDetailArea:not(:last-child) {
    border-bottom: 1px solid #AEAEAE;
  }
</style>
